import styled from 'styled-components';
import { layout, transitions } from '../../theme';

export const Wrapper = styled.div`
  bottom: 0;
  cursor: pointer;
  left: -2px;
  overflow: visible;
  position: absolute;
  right: -2px;
  top: 0;
`;

export const Track = styled.div`
  background: currentColor;
  bottom: 0;
  left: 2px;
  overflow: visible;
  pointer-events: none;
  position: absolute;
  right: 2px;
  top: 0;
  transition: background ${transitions.COLOR};
`;

export const HandlePosition = styled.div`
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
`;

export const Handle = styled.div`
  background: ${props => props.background};
  text-align: center;
  transform: translate3d(-50%, -50%, 0);
  transition: background ${transitions.COLOR};
  width: ${layout.SPACING * 2.5}rem;
`;
